import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getNews } from "../Service/Api";
const News = () => {
  const [data, setData] = useState([]); // State for gallery data
  const [loading, setLoading] = useState(true); // State for loading indicator

  useEffect(() => {
    const fetchData = async () => {
      try {
        const topperData1 = await getNews();
        const topperData = topperData1.filter(
          (item) => item.school === "FARRUKHABAD" && item.category === "News",
        );
        setData(topperData);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
        // Handle error (e.g., show error message)
      } finally {
        setLoading(false); // Set loading to false after data fetching is complete
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="newsbg">
        <marquee
          onMouseOver={(event) => event.currentTarget.stop()}
          direction="up"
          onMouseOut={(event) => event.currentTarget.start()}
        >
          <ul className="newsboxlist">
            {data.length > 0 ? (
              data.map((item, index) => (
                <li key={index}>
                  <div className="newsbox">
                    <div className="icon">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/arrow.png"
                        className="img-fluid"
                      />
                    </div>
                    <div className="newsdesc">
                      <h6>{item.title}</h6>
                      <p>{item.description}</p>
                      {item.attachments && item.attachments.length > 0 && (
                        <Link
                          to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`}
                          target="_blank"
                        >
                          Attachment
                        </Link>
                      )}
                    </div>

                    <div className="news-date">
                      {new Date(item.fromDate).getDate()}{" "}
                      <span>
                        {new Date(item.fromDate).toLocaleString("default", {
                          month: "short",
                        })}
                      </span>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <li>
                <div className="newsbox">
                  <div className="icon">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/arrow.png"
                      className="img-fluid"
                    />
                  </div>
                  <div className="newsdesc">
                    <h6>News Title</h6>
                    <p>Stay Tunned For More Updates</p>
                  </div>
                  <div className="news-date">
                    DD<span>MM</span>
                  </div>
                </div>
              </li>
            )}
            {/* <li>
                <div className="newsbox">
                <div className='icon'>
                    <img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/arrow.png' className='img-fluid' />
                  </div>
                  <div className="newsdesc">
                    <h6>Notice Regarding Admission for Nursery 2025</h6>
                    <p>Notice for Nursery Registration form 2025-2026 Notice Regarding...</p>
                  </div> 
                  <div className='news-date'>
                   19<span>Nov</span>
                  </div>
                </div>
                
              </li>
              <li>
                <div className="newsbox">
                <div className='icon'>
                    <img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/arrow.png' className='img-fluid' />
                  </div>
                  <div className="newsdesc">
                    <h6>Wisdom comes not from age but from learning.</h6>
                    <p>On 29/06/2024 a seminar was held for teachers in the school. The topic of the session was “Act...</p>
                  </div> 
                  <div className='news-date'>
                   01<span>JUL</span>
                  </div>
                </div>
              
              </li>
              <li>
                <div className="newsbox">
                <div className='icon'>
                    <img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/arrow.png' className='img-fluid' />
                  </div>
                  <div className="newsdesc">
                    <h6>The Harder you work for something the greater you feel when you achieve it “”Anand Bhawan...</h6>
                    <p>The Harder you work for something the greater you feel when you achieve it “Anand Bhawan School delivers outstanding result in ICSE& ISC...”</p>
                  </div> 
                  <div className='news-date'>
                   08<span>MAY</span>
                  </div>
                </div>
               
              </li> */}
          </ul>
        </marquee>
        <Link to="/News">
          <button className="readmore m-auto d-block mt-2"> View More</button>
        </Link>
      </div>
    </>
  );
};

export default News;
